import { render, staticRenderFns } from "./IssueFile.vue?vue&type=template&id=6c59c5dd&scoped=true"
import script from "./IssueFile.vue?vue&type=script&lang=js"
export * from "./IssueFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c59c5dd",
  null
  
)

export default component.exports